import { render, staticRenderFns } from "./FormStepComponent.vue?vue&type=template&id=eafc8ab6"
import script from "./FormStepComponent.vue?vue&type=script&lang=ts"
export * from "./FormStepComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports